import React, { Component } from 'react';
import SaleC from '../modules/components/SaleC';
// @observer
export default class SaleExtra extends Component {
    render() {
        const { saleExtra, visibleExtras, height, paddingBloque, busy, moneyName, quantityExtras, lineTotalExtras, handleKeyMinusExtras, handleKeyPlusExtras } = this.props;
        if (!visibleExtras || saleExtra.length <= 0) {
            return null;
        }
        return (React.createElement(React.Fragment, null, saleExtra.map((item, index, lista) => {
            return (React.createElement(SaleC, { key: item.name, itemExtra: item, index: index, lista: lista, height: height, paddingBloque: paddingBloque, busy: busy, moneyName: moneyName, handleKeyMinus: handleKeyMinusExtras, handleKeyPlus: handleKeyPlusExtras, quantity: quantityExtras, lineTotal: lineTotalExtras }));
        })));
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/SaleExtra.tsx
// module id = 555
// module chunks = 0